import { Jumplinks } from '@google/glue';
import './navigation.scss';

const CSS_CLASSES = {
  navigation: "glue-jumplinks",
};

export class NavigationComponent {
  constructor() {

    this.init();
  }

  init() {
   this.initNavigation(); 
  }

  initNavigation(){
    const navigationElement = document.querySelector<HTMLDivElement>(`.${CSS_CLASSES.navigation}`);
    if (navigationElement) new Jumplinks(navigationElement, {belowHeader: true});
  }
}